import { Component, OnDestroy, ViewChild } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular/ui/popup';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { Subscription } from 'rxjs';
import { PopupService } from '../../services/popup.service';

@Component({
  selector: 'app-changehistory-popup',
  templateUrl: './changehistory-popup.component.html',
  styleUrls: ['./changehistory-popup.component.scss'],
  standalone: false,
})
export class ChangeHistoryPopupComponent implements OnDestroy {
  @ViewChild('popup', { static: false }) popup: DxPopupComponent;
  @ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

  dataSource: any[] = [];
  onClose: (e) => void;

  subscription_get_PopupAsObservable: Subscription;

  constructor(private popupService: PopupService) {
    this.onClickClose = this.onClickClose.bind(this);

    this.subscription_get_PopupAsObservable = this.popupService.get_changeHistoryPopupAsObservable.subscribe((context) => {
      if (context !== null && context !== undefined && context.open === true) {
        this.onClose = context.closeCb;
        this.dataSource = context.data ? [context.data] : [];
        this.popup.instance.show();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription_get_PopupAsObservable) {
      this.subscription_get_PopupAsObservable.unsubscribe();
    }
  }

  onPopupShown(): void {
    this.dataGrid?.instance.updateDimensions();
  }

  onPopupHidden(): void {
    const onClose = this.onClose;
    this.onClose = null;
    this.dataSource = [];
    if (onClose) {
      onClose(3);
    }
  }

  onClickClose(e) {
    this.popup.instance.hide();
  }
}
